<template><div><h1>为什么部分组件要加<code>x-</code>前缀</h1>
<p>若不更名，可能在开发时与标准 html 标签相同而导致冲突或者 bug，比如 <code>Dialog</code>, <code>Switch</code> 等。从Vue@2.x开始已经强制不能使用原生html标签。</p>
</div></template><script>
export default {
  head: {"title":"为什么部分组件要加`x-`前缀 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// why-use-x-prefix-for-components-31.vue?41be46b8